<template>
    <div class="exception-body error">
        <!-- <div class="exception-topbar">
            <a id="logolink" @click="goDashboard" class="layout-topbar-logo">
                <img :src="'assetss/layout/images/logo-' + (colorScheme === 'dark' ? 'freya-whites' : 'freyas') + '.svg'" alt="Samsung Account-Book"/>
            </a>
        </div> -->
        <div class="exception-wrapper">
            <div class="exception-content">
                <div class="privacy-policy-outer">
                    <p class="new-one">
                        삼성물산(주) 건설부문은 영수증 기반 가계부 사내실증 서비스 제공을 위하여 아래와 같이 개인정보를 수집∙이용하고 제3자에게 제공하고자 합니다. 내용을 자세히 읽어 보시고, 모든 내용을 이해하신 후 동의여부를 결정해 주시기 바랍니다.
                    </p>

                    <h4>▶︎ 개인정보 수집 및 이용에 관한 사항</h4>

                    <div class="table-wrap">
                        <table style="width: 100%">
                            <tr>
                                <th colspan="2">항목</th>
                                <th>수집·이용 목적</th>
                                <th>보유·이용 기간</th>
                            </tr>
                            <tr>
                                <td>회원가입</td>
                                <td>이메일</td>
                                <td>아이디, 비밀번호 찾기</td>
                                <td>1년 또는 회원탈퇴 시 (서비스 종료 후 폐기)</td>
                            </tr>
                            <tr>
                                <td>회원가입</td>
                                <td>성별, 연령대, 자녀 유무 및 연령대, 반려동물 유무 및 유형</td>
                                <td>소비취향분석 리포트 서비스 제공</td>
                                <td>&nbsp;</td>
                            </tr>
                            <tr>
                                <td>영수증 등록</td>
                                <td>거래일시, 상호명, 상호주소, 상품명, 구매단가, 구매수량, 구매총금액</td>
                                <td>영수증 기반 가계부 사내 실증 서비스 제공</td>
                                <td>3년 또는 회원탈퇴 시 (서비스 개선을 위한 분석 자료로 활용 후 폐기)</td>
                            </tr>
                            <tr>
                                <td>서비스 이용 전반</td>
                                <td>쿠키, 기기 브라우저 관련 데이터, IP 주소, 사이트/앱 활동 수집 (개인 식별 정보 미전송)</td>
                                <td>서비스 이용자 통계 분석</td>
                                <td>&nbsp;</td>
                            </tr>
                        </table>
                    </div>

                    <h4>▶︎ 개인정보 제3자 위탁 및 제공에 관한 사항</h4>

                    <p class="nomar">
                        [개인정보의 제공] <br />
                        회사는 원칙적으로 개인정보를 외부에 공개하지 않으며 아래의 경우에는 예외로 합니다<br />
                        . 법 규정에 의하거나, 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우 <br />
                        [개인정보의 위탁] <br />
                        개인정보 보호법 등 관련 법령에 의거하여, 귀하의 개인정보의 수집·취급·관리 등의 처리를 수탁자에게 위탁하여 운영하고 있는 바, 이에 관하여 아래와 같이 알려 드립니다. 위탁계약 시 개인정보보호의 안전을 기하기 위하여
                        개인정보보호관련 지시 엄수, 개인정보에 관한 금지사항 및 사고시의 책임부담 등을 명확히 규정하고 있습니다. 동업체가 변경될 경우, 회사는 변경된 업체명을 개인정보 처리방침에 공지합니다.<br />
                    </p>
                    <ul>
                        <li>위탁업무 내용: 사용자 어플리케이션 서비스 제공을 위한 시스템 개발 및 운영 업무</li>
                        <li>처리 범위: 개인정보 수집, 생성, 기록, 저장, 보유, 가공, 편집, 검색, 출력, 정정, 복구, 이용, 제공, 공개, 파기</li>
                        <li>수탁 협력사: ㈜디비스쿨</li>
                    </ul>

                    <p>위의 개인정보 수집∙이용에 대한 동의를 거부할 권리가 있습니다. 그러나 동의를 거부할 경우 원활한 서비스 이용에 제한을 받을 수 있습니다.</p>

                    <p>삼성물산㈜ 건설부문(이하 ΄회사΄)은 개인정보보호법 제30조에 따라 정보주체의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리방침을 수립∙공개합니다.</p>

                    <h4>1. 개인정보 항목과 수집/이용 목적 및 기간</h4>
                    <div class="table-wrap">
                        <table style="width: 100%">
                            <tr>
                                <th colspan="2">항목</th>
                                <th>수집·이용 목적</th>
                                <th>보유·이용 기간</th>
                            </tr>
                            <tr>
                                <td>회원가입</td>
                                <td>이메일,비밀번호(간편 비밀번호 포함)</td>
                                <td>아이디, 비밀번호 찾기</td>
                                <td>회원탈퇴 시까지 ( 미탈퇴 시 사내실증 서비스 종료시 까지)</td>
                            </tr>
                            <tr>
                                <td>회원가입</td>
                                <td>성별, 연령대, 자녀 유무, 자녀 연령대(해당 시), 반려동물 유무, 반려동물 유형(해당 시)</td>
                                <td>소비취향분석 리포트 <br />서비스 제공</td>
                                <td>&nbsp;</td>
                            </tr>
                            <tr>
                                <td>영수증 등록</td>
                                <td>거래일시, 상호명, 상호주소, 상품명, 구매단가, 구매수량, 구매총금액</td>
                                <td>영수증 기반 가계부 <br />사내 실증 서비스 제공</td>
                                <td>회원탈퇴 시까지 (미탈퇴 시 사내실증 서비스 종료 후 3년간) * 서비스 개선을 위한 분석자료 활용 후 폐기</td>
                            </tr>
                            <tr>
                                <td>서비스 이용 전반</td>
                                <td>쿠키, 기기 브라우저 관련 데이터, IP 주소, 사이트/앱 활동 수집 (개인 식별 정보 미전송)</td>
                                <td>서비스 이용자 통계 분석</td>
                                <td>&nbsp;</td>
                            </tr>
                        </table>
                    </div>
                    <p>
                        회원탈퇴 시 회원정보는 즉시 삭제되나, 관계 법령의 규정에 의하여 보존할 필요가 있는 경우 회사는 아래와 같이 관계법령에서 정한 일정기간 동안 회원정보를 보관합니다.<br />
                        - 서비스 이용 관련 개인정보(로그기록): 3개월(통신비밀보호법)
                    </p>

                    <h4>2. 개인정보의 제3자 제공 및 처리 위탁</h4>
                    <p class="nomar">① 회사는 원활한 개인정보 업무처리를 위하여 아래와 같이 외부 전문업체에 개인정보 처리업무를 위탁하고 있습니다. 업체가 변경되는 경우, 변경된 업체명을 공지합니다.</p>
                    <ul>
                        <li>위탁업무 내용: 사용자 어플리케이션 서비스 제공을 위한 시스템 개발 및 운영 업무</li>
                        <li>수탁 협력사: ㈜디비스쿨</li>
                    </ul>
                    <p class="mar-btm-15">
                        ② 회사는 위탁계약 체결시 개인정보 보호법 제26조에 따라 위탁업무 수행목적 외 개인정보 처리금지, 기술적•관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리•감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가
                        개인정보를 안전하게 처리하는지를 감독하고 있습니다.
                    </p>

                    <p class="nomar">③ 일부 개인정보의 경우, 서비스 제공 및 이용자 편의 증진 등을 위하여 국외 업체에 위탁, 보관하고 있습니다.</p>
                    <ul class="mar-btm-15">
                        <li>이전 받는 업체명 및 연락처: Google Inc. (https://analytics.google.com/)</li>
                        <li>이전되는 국가: 미국</li>
                        <li>이전일시 및 방법: 웹 사이트 내에 방문자 서비스 이용 시점에 네트워크를 통한 전송</li>
                        <li>이전되는 개인정보 항목: 쿠키, 기기 브라우저 관련 데이터, IP 주소, 사이트/앱 활동 수집 (개인 식별 정보 미전송)</li>
                        <li>이전 받는 자의 이용 목적 및 보유•이용 기간: 웹사이트에서 일어나는 사용자 상호작용에 대한 통계 측정용 (IP 주소 서비스 보안 제공 및 유지,</li>
                        <li>사용자 접속 국가 정보를 알려주는 역할), 사용자 및 이벤트 데이터 보관 38개월</li>
                    </ul>
                    <p class="nomar">
                        ④ 개인정보의 제3자 제공 회사는 정보주체의 개인정보를 제1조(개인정보의 처리목적)에서 명시한 범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등 개인정보보호법제17조에 해당하는 경우에만 개인정보를 제3자에게
                        제공합니다. 또한 주민등록번호의 제공은 법령에 근거가 있는 경우에 한정합니다.
                    </p>
                    <ul>
                        <li>해당 서비스는 개인정보의 제3자 제공이 없습니다.</li>
                    </ul>

                    <h4>3. 개인정보의 파기절차 및 방법</h4>
                    <p class="mar-btm-15">이용자 및 정보주체의 개인정보는 원칙적으로 개인정보의 수집 및 이용목적이 달성되면 지체 없이 파기합니다. 삼성물산의 개인정보 파기절차 및 방법은 다음과 같습니다.</p>
                    <p class="nomar">① 파기절차</p>
                    <ul>
                        <li>회원가입 등을 위해 입력한 정보는 목적이 달성된 후 별도의 DB로 옮겨져 내부 방침 및 기타 관련 법령에 의한 정보보호 사유에 따라 (1. 개인정보 항목과 수집/이용 목적 및 기간) 일정 기간 저장된 후 파기됩니다.</li>
                        <li>동 개인정보는 법률에 의한 경우가 아니고서는 보유되는 이외의 다른 목적으로 이용되지 않습니다</li>
                    </ul>
                    <p class="nomar">② 파기방법</p>
                    <ul>
                        <li>전자적 파일 형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.</li>
                    </ul>

                    <h4>4. 정보주체의 권리∙의무 및 행사방법</h4>

                    <p class="mar-btm-15">
                        ① 이용자 및 정보주체는 언제든지 등록되어 있는 자신의 개인정보를 열람하거나 정정·삭제, 이용내역 확인, 처리정지 및 동의철회를 요청하실 수 있습니다. 개인정보 열람, 정정·삭제, 이용내역 확인, 처리정지, 동의철회를 하고자 할 경우에는
                        하기 7항에 안내된 개인정보보호 실무담당자에게 전화 또는 이메일주소로 연락하시면 본인 확인 절차를 거쳐 지체 없이 조치하겠습니다.
                    </p>

                    <p class="mar-btm-15">
                        ② 이용자 및 정보주체가 개인정보의 오류에 대한 정정을 요청하신 경우에는 정정을 완료하기 전까지 당해 개인정보를 이용 또는 제공하지 않습니다. 또한 잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정된 처리결과를 제3자에게 지체
                        없이 통지하여 정정이 이루어지도록 조치하겠습니다.
                    </p>

                    <p class="mar-btm-15">
                        ③ 삼성물산은 이용자 및 정보주체가 열람, 정정, 삭제, 처리정지 및 동의철회 요청 시 지체 없이 조치할 수 없는 경우 그 사유를 해당 이용자 및 정보주체에게 통지하고 조치를 연기할 수 있으며, 그 사유가 소멸한 때에는 지체 없이 요청
                        사항이 조치될 수 있도록 하겠습니다. 단, 개인정보의 삭제요구는 다른 법령에서 그 개인정보가 수집 대상으로 명시되어 있는 경우에는 진행할 수 없습니다.
                    </p>

                    <p class="mar-btm-15">
                        ④ 이용자 및 정보주체는 개인정보의 열람, 정정, 삭제, 이용내역 확인, 처리정지 및 동의철회 요청에 대해 삼성물산이 거부하였을 경우 삼성물산에 이의를 제기하실 수 있으며, 개인정보보호법 시행규칙 별지 8호, 9호 서식에 따라 진행하실 수
                        있습니다.
                    </p>

                    <p class="mar-btm-15">
                        ⑤ 이용자 및 정보주체의 권리 행사는 해당 이용자 및 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수 있습니다. 이 경우 개인정보보호법 시행규칙 별지 제11호 서식에 따른 위임장을 제출하셔야 합니다.
                    </p>
                    <p class="nomar">※ 해당 서비스는 만 14세 미만의 고객정보는 원칙적으로 수집하지 않습니다.</p>
                    <ul>
                        <li>기타 개인정보의 열람 및 삭제, 처리정지 제한은 개인정보보호법 제35조, 37조를 따르고 있습니다.</li>
                    </ul>

                    <h4>5. 개인정보의 안전성 확보 조치에 관한 사항</h4>
                    <p class="mar-btm-15">이용자 및 정보주체의 개인정보를 취급함에 있어 분실, 도난, 유출, 변조 또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은 기술적·관리적 대책을 강구하고 있습니다.</p>

                    <ul>
                        <li>관리적 조치 : 내부관리계획 수립·시행, 정기적 직원 교육 등</li>
                        <li>기술적 조치 : 개인정보처리시스템 등의 접근권한 관리, 접근통제시스템 설치, 고유식별정보 등의 암호화, 보안프로그램 설치</li>
                        <li>물리적 조치 : 전산실 등의 접근통제</li>
                    </ul>

                    <h4>6. 개인정보 자동 수집 장치의 설치/운영 및 거부에 관한 사항</h4>

                    <p class="mar-btm-15">① 회사는 이용자에게 개별적인 맞춤서비스를 제공하기 위해 이용정보를 저장하고 수시로 불러오는 ΄쿠키(Cookie)΄를 사용합니다.</p>

                    <p class="mar-btm-15">② 쿠키는 웹사이트를 운영하는데 이용되는 서버(http)가 이용자의 PC 브라우저에게 보내는 소량의 정보이며 이용자들의 PC 내 하드디스크에 저장되기도 합니다.</p>

                    <p class="mar-btm-15">
                        ③ 회사는 Google Inc.("Google")이 제공하는 서비스인 Google Analytics를 이용해 귀하의 웹사이트 이용을 분석합니다. Google Analytics를 통해 생성되는 정보는 Google 개인정보 취급방침의 적용을 받으며, 미국 내 Google 서버로 전송 후
                        저장됩니다. Google은 회사를 대신해 정보를 처리하여 귀하의 웹사이트 사용을 평가하고, 웹사이트 활동에 대한 보고서를 작성하여 인터넷 사용과 관련된 다른 서비스를 제공합니다. 귀하가 브라우저 설정을 통해 쿠키를 앞서 언급한 목적에
                        사용하는 것을 거부할 수 있지만, 그 경우 웹사이트의 모든 기능을 충분히 사용하지 못할 수 있습니다. 귀하는 tools.google.com/dlpage/gaoptout 에서 현재 귀하의 웹 브라우저에 대한 부가 기능을 다운로드 및 설치하여 추가로 (IP 주소를
                        비롯한) 귀하의 사용 정보의 수집과 정보 처리를 옵트아웃할 수 있습니다. Google의 귀하 정보 이용에 관한 보다 자세한 내용은 www.google.com/analytics/learn/privacy.html 을 참고하시기 바랍니다.
                    </p>

                    <h4>7. 개인정보 보호책임자 및 담당자 연락처</h4>
                    <p>
                        이용자 및 정보주체의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기 위하여 삼성물산은 개인정보 보호책임자를 두고 있습니다.개인정보와 관련한 문의사항이 있으시면 아래의 개인정보 보호책임자 또는 개인정보 관리실무자에게
                        연락 주시기 바랍니다. 귀하의 문의 사항에 신속하고 성실하게 답변해 드리겠습니다.
                    </p>

                    <div class="table-wrap-duble">
                        <table style="width: 100%">
                            <tr>
                                <th>개인정보 보호책임자</th>
                                <th>개인정보 관리실무자</th>
                            </tr>
                            <tr>
                                <td>
                                    성명 : 조혜정<br />
                                    소속 : 주택Biz개발팀 (스마트홈그룹) <br />
                                    직책 : 상무
                                </td>
                                <td>
                                    성명 : 박주현<br />
                                    소속 : 주택Biz개발팀 (스마트홈그룹)<br />
                                    직책 : 프로<br />
                                    이메일주소 : smart.home@samsung.com<br />
                                    전화번호 : 02-2145-7283
                                </td>
                            </tr>
                        </table>
                    </div>

                    <h4>8. 이용자의 권익침해에 대한 구제 방법</h4>
                    <p class="mar-btm-15">개인 정보침해에 대한 신고 상담이 필요하신 경우에는 7항의 개인정보 관리실무자에게 연락을 주시거나 아래 기관에 문의하시기 바랍니다.</p>

                    <ul>
                        <li>개인정보 침해신고센터 : (국번없이) 118 (http://privacy.kisa.or.kr)</li>
                        <li>개인정보 분쟁조정위원회 : 1833-6972 (www.kopico.go.kr)</li>
                        <li>대검찰청 사이버수사과 : (국번없이)1301, cid@spo.go.kr (http://spo.go.kr)</li>
                        <li>경찰청 사이버안전국 : (국번없이)182 (http://cyberbureau.police.go.kr)</li>
                    </ul>

                    <h4>9. 개인정보 처리방침 변경에 관한 사항 (고지의무)</h4>

                    <p>현 개인정보 처리방침은 2022.09.01부터 적용됩니다. 현 개인정보처리방침 내용 추가, 삭제 및 수정이 있을 시에는 개정 방침 시행일로부터 최소 7일전 고지할 것입니다.</p>

                    <!-- <a href="#" class="mybtn">동의하기</a> -->
                </div>
            </div>
            <div class="exception-footer">
                <!-- <h4>Rai Planner</h4>
                <h6>Copyright Ⓒ Rai Planner</h6> -->
            </div>
        </div>
    </div>
    <KakaoMap />
</template>

<script>
import KakaoMap from '../components/kakaoMap.vue';
import VueDaumMap from 'vue-daum-map';
export default {
    data() {
        return {
            appKey: 'd650a15bea81e28dadb716657ad03d75', // 테스트용 appkey
            center: { lat: 33.450701, lng: 126.570667 }, // 지도의 중심 좌표
            level: 3, // 지도의 레벨(확대, 축소 정도),
            mapTypeId: VueDaumMap.MapTypeId.NORMAL, // 맵 타입
            libraries: [], // 추가로 불러올 라이브러리
            map: null, // 지도 객체. 지도가 로드되면 할당됨.
            daum: null, // 다음 API 객체. 지도가 로드되면 할당됨.
        };
    },
    components: {
        KakaoMap,
    },
    computed: {
        colorScheme() {
            return this.$appState.colorScheme;
        },
    },
    methods: {
        goDashboard() {
            window.location = '/';
        },
        onLoad (map, daum) {
            this.map = map;
            this.daum = daum;
        }
    },
};
</script>
<style scoped>
body {
    background: #fafafa;
}

.title {
    text-align: center;
    padding: 16px 0px;
    /* font-family: 'SUIT'; */
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 135%;
    text-align: center;
    color: #333333;
}

.title-new {
    position: relative;
    background: #fff;
}
.cross {
    position: absolute;
    right: 22px;
    top: 22px;
}

.privacy-policy-outer {
    background: #fafafa;
    padding: 24px 16px 24px;
}
.privacy-policy-outer h4 {
    font-family: 'SUIT';
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 150%;
    color: #333333;
    margin-bottom: 10px;
}

.privacy-policy-outer p {
    font-family: 'SUIT';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 150%;
    color: #333333;
    margin-bottom: 38px;
}
.privacy-policy-outer p.new {
    margin-bottom: 0px;
}
.privacy-policy-outer p.new-one {
    margin-bottom: 10px;
}

.privacy-border {
    border: 1px solid #e0e0e0;
    padding: 16px;
}

.confirmbtn {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 12px 16px;
    gap: 4px;

    height: 44px;
    background: #5140ff;
    border-radius: 8px;
    font-family: 'SUIT';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    color: #ffffff;
    text-decoration: none;
}

.round {
    position: relative;
    height: 32px;
    margin: 21px 0px;
    display: flex;
    align-items: center;
}
.round span {
    font-family: 'SUIT';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 130%;
    display: flex;
    align-items: center;
    color: #828282;
    margin-left: 31px;
}

.round label {
    background-color: #5140ff;
    border: 1px solid #ccc;
    border-radius: 50%;
    cursor: pointer;
    height: 28px;
    left: 0;
    position: absolute;
    top: 0;
    width: 28px;
}

.round label:after {
    border: 2px solid #cfcfcf;
    border-top: none;
    border-right: none;
    content: '';
    height: 6px;
    left: 7px;

    position: absolute;
    top: 8px;
    transform: rotate(-45deg);
    width: 12px;
    z-index: 8;
}

.round input[type='checkbox'] {
    visibility: hidden;
}

.round input[type='checkbox']:checked + label {
    background: #fff;
    border-color: #cfcfcf;
    z-index: 999;
}

.round input[type='checkbox']:checked + label:after {
    opacity: 1;
}

@media only screen and (max-width: 768px) {
    .cross {
        width: 14px;
    }
}
table,
th,
td {
    /* border: 1px solid black; */
    border-collapse: collapse;
}
.table-wrap {
    position: relative;
    width: 100%;
    margin: 5px 0 15px;
}
.table-wrap table {
    width: 100%;
    position: relative;
}

.table-wrap table tr th {
    border: 1px solid #ddd;
    border-collapse: collapse;
    padding: 10px 5px;
    text-align: center;
    font-weight: 400;
    font-size: 11px;
    line-height: 150%;
    color: #000000;
    font-family: 'SUIT';
}
.table-wrap table tr th:first-child {
    width: 50%;
}
.table-wrap table tr th:last-child {
    width: 27%;
}

.table-wrap table tr td {
    border: 1px solid #ddd;
    border-collapse: collapse;
    padding: 10px 10px;
    text-align: center;
    font-weight: 400;
    font-size: 11px;
    line-height: 150%;
    color: #000000;
    font-family: 'SUIT';
}
.table-wrap table tr td:last-child {
    font-weight: 600;
}
.table-wrap table tr td:nth-child(2) {
    width: 25%;
}

.privacy-policy-outer ul {
    position: relative;
    width: 100%;
    padding: 0;
    margin: 0 0 10px;
}
.privacy-policy-outer li {
    font-weight: 400;
    font-size: 12px;
    line-height: 150%;
    color: #000000;
    font-family: 'SUIT';
    padding-left: 15px;
    position: relative;
    list-style-type: none;
}
.privacy-policy-outer li:after {
    content: '';
    position: absolute;
    width: 4px;
    height: 4px;
    background-color: #000;
    border-radius: 100%;
    top: 8px;
    left: 0;
}

.nomar {
    margin-bottom: 0 !important;
}
.mar-btm-15 {
    margin-bottom: 15px !important;
}

.table-wrap-duble {
    position: relative;
    width: 100%;
    margin: 5px 0 15px;
}
.table-wrap-duble table {
    width: 100%;
    position: relative;
}

.table-wrap-duble table tr th {
    border: 1px solid #ddd;
    border-collapse: collapse;
    padding: 10px 5px;
    text-align: center;
    font-weight: 400;
    font-size: 11px;
    line-height: 150%;
    color: #000000;
    font-family: 'SUIT';
    width: 50%;
}
.table-wrap-duble table tr td {
    border: 1px solid #ddd;
    border-collapse: collapse;
    padding: 10px 10px;
    text-align: left;
    font-weight: 400;
    font-size: 11px;
    line-height: 150%;
    color: #000000;
    font-family: 'SUIT';
}

a.mybtn {
    position: relative;
    width: 100%;
    padding: 12px;
    background: #5140ff;
    border-radius: 8px;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    color: #ffffff;
    display: flex;
    box-sizing: border-box;
    text-align: center;
    text-decoration: none;
    justify-content: center;
}
</style>
